import { render } from "./PostcodeLookup.vue?vue&type=template&id=0f9f3d7e&scoped=true"
import script from "./PostcodeLookup.vue?vue&type=script&lang=js"
export * from "./PostcodeLookup.vue?vue&type=script&lang=js"

import "./PostcodeLookup.vue?vue&type=style&index=0&id=0f9f3d7e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0f9f3d7e"

export default script